import { clearCatalogTexturesCache } from '@utils/sceneObjects/linked/textureCatalogApi'
import { clearTextureCatalogMatchCaches } from '@utils/sceneObjects/linked/resolveTextureCatalogMatch'
import { clearLinkedUnitOptionsCache } from '@utils/sceneObjects/linked/fetchLinkedUnitOptions'

/** Invalida cachés de catálogo/zona/opciones enlazadas tras cambio de unidad o catalogID. */
export function invalidateLinkedTextureCaches(): void {
  clearTextureCatalogMatchCaches()
  clearCatalogTexturesCache()
  clearLinkedUnitOptionsCache()
}
